var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c(
        "b-row",
        { staticClass: "justify-content-md-center text-center" },
        [
          _c(
            "b-col",
            { attrs: { sm: "auto" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Année",
                    "label-class": "font-weight-bold",
                    "label-for": "annee",
                  },
                },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedYear,
                          expression: "selectedYear",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { name: "annee" },
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedYear = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function ($event) {
                            return _vm.checkDon()
                          },
                        ],
                      },
                    },
                    [
                      _c("option"),
                      _vm._l(_vm.years, function (y) {
                        return _c(
                          "option",
                          { key: y, domProps: { value: y } },
                          [_vm._v(_vm._s(y))]
                        )
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.saisieError.length > 0
        ? _c(
            "span",
            [
              _c("p", [
                _vm._v(
                  " Les saisies suivantes comportent des erreurs, veuillez les modifier avant de pouvoir continuer "
                ),
              ]),
              _c("custom-tab", {
                attrs: {
                  tableData: _vm.saisieError,
                  tableFields: _vm.errorTabFields,
                },
              }),
              _c("b-row", {
                staticClass: "justify-content-md-center text-center",
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }